// extracted by mini-css-extract-plugin
export default {"body":"GlobalErrorBoundary_body__A-No1","errorBoundary":"GlobalErrorBoundary_errorBoundary__bFCGo","header":"GlobalErrorBoundary_header__cRQA8"};